import UserIcon from './UserIcon';

export default UserIcon;


// WEBPACK FOOTER //
// ./src/components/UserIcon/index.js